import React, { Component } from 'react';
import { RRServer } from '../../utils/lib';
import Footer from '../Footer';
import { SelectColumnFilter, TimeColumnFilter } from '../TableComp/Filter';
import TableContainer from '../TableComp/TableContainer';
import TopBar from '../TopBar';
import firebase from '../../utils/Firebase';
import Corporate from './Corporate';
import LiveClassesMini from './MiniTableCards/LiveClassesMini';
import InstallmentsMini from './MiniTableCards/InstallmentsMini';
import ScoresMini from './MiniTableCards/ScoresMini';
import EnquiryMini from './MiniTableCards/EnquiryMini';


const cards = [
    {
        title: " Live Classes",
        text: "3:00 PM to 4:00 PM",
        link: "liveClasses",
        TableColumn: [

            {
                Header: 'Student Name',
                accessor: 'studentName',
                // Filter: SelectColumnFilter,
                disableFilters: true
            },
            {
                Header: 'Instructor Name',
                accessor: 'instructorName',
                // Filter: SelectColumnFilter,
                disableFilters: true
            },
            {
                Header: 'Status',
                accessor: 'status',
                // Filter: SelectColumnFilter,
                disableFilters: true
            }
        ],
        TableData: [
            { studentName: 'praveen', instructorName: 'abcd', status: <span className="badge bg-secondary p-2">Yet to Board</span> },
            { studentName: 'praveen', instructorName: 'abcd', status: <span className="badge bg-warning p-2">On Going</span> },
            { studentName: 'praveen', instructorName: 'abcd', status: <span className="badge bg-success p-2">Success</span> },
            { studentName: 'praveen', instructorName: 'abcd', status: <span className="badge bg-danger p-2">Not Completed</span> },
            { studentName: 'praveen', instructorName: 'abcd', status: <span className="badge bg-success p-2">Success</span> },
        ]

    }

]
const columns1 = [

    {
        Header: 'Student Name',
        accessor: 'studentName',
        // Filter: SelectColumnFilter,
        disableFilters: true
    },
    {
        Header: 'Instructor Name',
        accessor: 'instructorName',
        // Filter: SelectColumnFilter,
        disableFilters: true
    },
    {
        Header: 'Status',
        accessor: 'status',
        // Filter: SelectColumnFilter,
        disableFilters: true
    }
]

const Data1 = [
    { studentName: 'praveen', instructorName: 'abcd', status: <span className="badge bg-secondary p-2">Yet to Board</span> },
    { studentName: 'praveen', instructorName: 'abcd', status: <span className="badge bg-warning p-2">On Going</span> },
    { studentName: 'praveen', instructorName: 'abcd', status: <span className="badge bg-success p-2">Success</span> },
    { studentName: 'praveen', instructorName: 'abcd', status: <span className="badge bg-danger p-2">Not Completed</span> },
    { studentName: 'praveen', instructorName: 'abcd', status: <span className="badge bg-success p-2">Success</span> },
]

const columns2 = [

    {
        Header: 'School',
        accessor: 'school',
        disableFilters: true
    },
    {
        Header: 'Name',
        accessor: 'name',
        disableFilters: true
    },
    {
        Header: 'No Of Installments',
        accessor: 'noOfInstallments',
        disableFilters: true
    }
]

const Data2 = [
    { school: 'praveen', name: 'abcd', noOfInstallments: 1 },
    { school: 'praveen', name: 'abcd', noOfInstallments: 2 },
    { school: 'praveen', name: 'abcd', noOfInstallments: 3 },
    { school: 'praveen', name: 'abcd', noOfInstallments: 4 },
    { school: 'praveen', name: 'abcd', noOfInstallments: 5 },
]

const columns3 = [

    {
        Header: 'School',
        accessor: 'school',
        disableFilters: true
    },
    {
        Header: 'User',
        accessor: 'user',
        disableFilters: true
    },
    {
        Header: 'Game',
        accessor: 'game',
        disableFilters: true
    },
    {
        Header: 'Score',
        accessor: 'score',
        disableFilters: true
    }
]

const Data3 = [
    { school: 'praveen', user: 'abcd', game: 'one', score: 1 },
    { school: 'praveen', user: 'abcd', game: 'one', score: 2 },
    { school: 'praveen', user: 'abcd', game: 'one', score: 3 },
    { school: 'praveen', user: 'abcd', game: 'one', score: 4 },
    { school: 'praveen', user: 'abcd', game: 'one', score: 5 },
]

interface DashboardState {
    isSearch: boolean,
    isSignedIn: boolean,
    currentLoggedInSchool: any,
    corporate: boolean,
    displayName: any,
    scores: any[],
    schools: any[],
    users: any[],
    corporateCodesCount: number,
    corporateCodes: any[],
    studentsCount: number,
    drivingSchoolCodesCount: number,
    instructorCount: number,
    adminCount: number
}




class Dashboard extends Component<{}, DashboardState> {
    unregisterAuthObserver: any;

    state: DashboardState = {
        isSearch: false,
        isSignedIn: false,
        currentLoggedInSchool: null,
        corporate: false,
        displayName: null,
        scores: [],
        schools: [],
        users: [],
        corporateCodes: [],
        studentsCount: 0,

        corporateCodesCount: 0,
        drivingSchoolCodesCount: 0,
        instructorCount: 0,
        adminCount: 0
    }

    componentDidMount() {
        const claimsString: any = localStorage.getItem('claims');
        const claims = JSON.parse(claimsString);
        let corporate = false;
        if (!!claims) {
            corporate = !!claims.corporate;
        }


        this.unregisterAuthObserver = firebase.auth().onAuthStateChanged(
            (user: any) => {
                if (!!user) {
                    const uid = user.uid;
                    RRServer.list({ table: RRServer.Tables.DRIVING_SCHOOLS, forCurrentUser: false, where: [['firebaseUserUid', '==', uid]] })
                        .then((r: any) => this.setState({ isSignedIn: true, currentLoggedInSchool: r?.data.data[0], corporate }))
                        .catch((r: any) => console.log(r))
                    this.setState({ displayName: user.displayName, corporate })
                } else {
                    this.setState({ isSignedIn: false })

                }
            }
        );
       
        if (!claims.drivingSchoolId) {
            alert('Driving school Not Found');
            return;
        }

        if (claims.drivingSchoolId === "*") {
            Promise.all([
                RRServer.list({
                    table: RRServer.Tables.DRIVING_SCHOOLS,
                    forCurrentUser: false,
                }),
                RRServer.list({
                    table: RRServer.Tables.USERS,
                    forCurrentUser: false
                }),
                RRServer.list({
                    table: 'corporate_codes',
                    forCurrentUser: false
                })]).then((results: any) => {
                    this.setState({
                        schools: results[0].data.data,
                        users: results[1].data.data,
                        corporateCodesCount: results[2].data.data.length,
                        corporateCodes: results[2].data.data,
                        drivingSchoolCodesCount: results[2].data.data.filter(({ type }: { type: string }) => type ? type.indexOf('DRIVING_') != -1 : false).length,
                        studentsCount: results[2].data.data.filter(({ type }: { type: string }) => type ? (type.indexOf('DRIVING_') != -1 && type.indexOf('DRIVING_SCHOOL_ADMIN') == -1 && type.indexOf('DRIVING_SCHOOL_INSTRUCTOR') == -1) : false).length,
                        instructorCount: results[2].data.data.filter(({ type }: { type: string }) => type === 'DRIVING_SCHOOL_INSTRUCTOR').length,
                        adminCount: results[2].data.data.filter(({ type }: { type: string }) => type === 'DRIVING_SCHOOL_ADMIN').length,
                    });
                })

        } else {

            Promise.all([
                RRServer.get({
                    table: RRServer.Tables.DRIVING_SCHOOLS,
                    id: claims.drivingSchoolId
                }),
                RRServer.list({
                    table: RRServer.Tables.USERS,
                    forCurrentUser: false,
                    where: [["drivingSchoolId", "==", claims.drivingSchoolId]]
                }),
                RRServer.list({
                    table: 'corporate_codes',
                    forCurrentUser: false,
                    where: [["companyId", "==", claims.drivingSchoolId]]
                })]).then((results: any) => {
                    this.setState({
                        schools: [results[0].data.data],
                        users: results[1].data.data,
                        corporateCodesCount: results[2].data.data.length,
                        corporateCodes: results[2].data.data,
                        drivingSchoolCodesCount: results[2].data.data.filter(({ type }: { type: string }) => type.indexOf('DRIVING_') != -1).length,
                        studentsCount: results[2].data.data.filter(({ type }: { type: string }) => type.indexOf('DRIVING_') != -1 && type.indexOf('DRIVING_SCHOOL_ADMIN') == -1 && type.indexOf('DRIVING_SCHOOL_INSTRUCTOR') == -1).length,
                        instructorCount: results[2].data.data.filter(({ type }: { type: string }) => type === 'DRIVING_SCHOOL_INSTRUCTOR').length,
                        adminCount: results[2].data.data.filter(({ type }: { type: string }) => type === 'DRIVING_SCHOOL_ADMIN').length,
                    });
                })


        }

    }

    componentWillUnmount() {
        this.unregisterAuthObserver();
    }

    getScoresForGame = (cid: string) => {
        RRServer.list({ table: RRServer.Tables.SCORES, forCurrentUser: false, where: [["cid", "==", cid]] })
            .then((r: any) => {
                console.log('Scores', r);
                this.setState({ scores: r.data.data })
            })
    }


    render() {
        function GetFormattedDate() {
            var todayTime = new Date();
            var month = todayTime.getMonth() + 1;
            var monthFormat = month.toString().length === 1 ? `0${month}` : month
            var day = todayTime.getDate();
            var dayFormat = day.toString().length === 1 ? `0${day}` : day
            var year = todayTime.getFullYear();
            return dayFormat + "/" + monthFormat + "/" + year;
          }
          const claimsString = localStorage.getItem('claims') || '{}';
          const claims = JSON.parse(claimsString);
          const isLoggedIn = localStorage.getItem('claims');
          const isSkl =  claims.drivingSchoolId !== "*" && claims.drivingSchoolId !== "#"? true : false;
          const isSuperAdmin = claims.drivingSchoolId === "*"? true : false
          const isClusterAdmin = claims.drivingSchoolId === "#" && claims?.userType === "CLUSTER"? true : false
          const isAssociationAdmin = claims.drivingSchoolId === "#" && claims?.userType === "ASSOCIATION"? true : false
        return (
            <>
                <TopBar title="Dashboard" />

                {console.log('dashh', this.state)}
                <div className='welcomeCard'>
                    <div className="info">
                        <h1>{`Hello, ${this.state?.currentLoggedInSchool?.drivingSchoolName}!`}</h1>
                        <p>Welcome to Rakshak admin panel</p>
                    </div>
                    <div className="image">
                       {this.state?.currentLoggedInSchool?.profileImage ? <img src={this.state?.currentLoggedInSchool?.profileImage} alt="WelcomeCard Image" /> : ""}
                    </div>
                </div>

                <div className='contentContainer dash'>
                    <div className='cards'>
                        <div className='cardA'>
                            <div className='left'>
                                <span className='title'>Instructor Count</span>
                                <span className='svg'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" className="bi bi-bar-chart-line" viewBox="0 0 16 16">
                                        <path d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1V2zm1 12h2V2h-2v12zm-3 0V7H7v7h2zm-5 0v-3H2v3h2z" />
                                    </svg>
                                </span>
                            </div>
                            <div className='right'>
                                <span className='count'>{this.state.instructorCount}</span>
                                <span className='date'>{GetFormattedDate()}</span>
                            </div>
                        </div>
                        <div className='cardB'>
                            <div className='left'>
                                <span className='title'>Student Count</span>
                                <span className='count'>{this.state.studentsCount}</span>
                            </div>
                            <svg width="100%" height="100%" id="svg" viewBox="0 0 1440 500" xmlns="http://www.w3.org/2000/svg" className="transition duration-300 ease-in-out delay-150"><path d="M 0,500 C 0,500 0,100 0,100 C 50.07010566317055,120.60677257184547 100.1402113263411,141.21354514369094 149,132 C 197.8597886736589,122.78645485630906 245.50926035780623,83.75259199708172 281,75 C 316.4907396421938,66.24740800291828 339.8227472424339,87.77608686798213 377,94 C 414.1772527575661,100.22391313201787 465.19975067245844,91.14306053098974 520,83 C 574.8002493275416,74.85693946901026 633.3782500677328,67.65167100805887 676,82 C 718.6217499322672,96.34832899194113 745.2872490566104,132.25025543677475 789,131 C 832.7127509433896,129.74974456322525 893.4727537058254,91.34730724484214 940,74 C 986.5272462941746,56.652692755157865 1018.821736120088,60.36051558385674 1062,81 C 1105.178263879912,101.63948441614326 1159.2403018138225,139.21063041973088 1201,135 C 1242.7596981861775,130.78936958026912 1272.217056624622,84.79696273721974 1310,72 C 1347.782943375378,59.203037262780256 1393.8914716876889,79.60151863139012 1440,100 C 1440,100 1440,500 1440,500 Z" stroke="none" strokeWidth="0" fill="#f4f8f844" className="transition-all duration-300 ease-in-out delay-150 path-0"></path><path d="M 0,500 C 0,500 0,200 0,200 C 42.77107729685028,218.62972203874847 85.54215459370056,237.25944407749694 135,231 C 184.45784540629944,224.74055592250306 240.60245892204802,193.59194572876072 282,186 C 323.397541077952,178.40805427123928 350.0480097181075,194.37277300746032 393,200 C 435.9519902818925,205.62722699253968 495.2055022055217,200.91696224139795 547,202 C 598.7944977944783,203.08303775860205 643.1299814598058,209.9593780269479 676,208 C 708.8700185401942,206.0406219730521 730.2745719552555,195.2455256508104 774,191 C 817.7254280447445,186.7544743491896 883.7717307191718,189.05851936981045 927,196 C 970.2282692808282,202.94148063018955 990.638505168057,214.52039686994772 1035,209 C 1079.361494831943,203.47960313005228 1147.6742486086,180.8598931503987 1194,181 C 1240.3257513914,181.1401068496013 1264.664500397543,204.0400305284575 1302,211 C 1339.335499602457,217.9599694715425 1389.6677498012286,208.97998473577127 1440,200 C 1440,200 1440,500 1440,500 Z" stroke="none" strokeWidth="0" fill="#f4f8f866" className="transition-all duration-300 ease-in-out delay-150 path-1"></path><path d="M 0,500 C 0,500 0,300 0,300 C 37.52952530373514,286.94301059464976 75.05905060747028,273.88602118929947 123,278 C 170.94094939252972,282.11397881070053 229.29332287385398,303.3989258374519 275,304 C 320.706677126146,304.6010741625481 353.7676578971135,284.51827546089294 390,279 C 426.2323421028865,273.48172453910706 465.6360455376922,282.52797231897637 512,284 C 558.3639544623078,285.47202768102363 611.6881599521178,279.36983526320165 660,272 C 708.3118400478822,264.63016473679835 751.6113146538366,255.99268662821692 799,271 C 846.3886853461634,286.0073133717831 897.8665814325356,324.6594182239308 933,318 C 968.1334185674644,311.3405817760692 986.9223596160214,259.36964047605977 1031,262 C 1075.0776403839786,264.63035952394023 1144.4439801033789,321.86201987183006 1191,335 C 1237.5560198966211,348.13798012816994 1261.3017199704632,317.18228003662 1299,304 C 1336.6982800295368,290.81771996338 1388.3491400147684,295.40885998169 1440,300 C 1440,300 1440,500 1440,500 Z" stroke="none" strokeWidth="0" fill="#f4f8f888" className="transition-all duration-300 ease-in-out delay-150 path-2"></path><path d="M 0,500 C 0,500 0,400 0,400 C 43.6449915798831,397.4792914706252 87.2899831597662,394.9585829412504 131,401 C 174.7100168402338,407.0414170587496 218.48505894081836,421.64495970562353 256,414 C 293.51494105918164,406.35504029437647 324.7697810769603,376.46157823625555 368,366 C 411.2302189230397,355.53842176374445 466.43581675134,364.5087273493543 510,369 C 553.56418324866,373.4912726506457 585.4869519176794,373.5035123663273 636,374 C 686.5130480823206,374.4964876336727 755.6163755779422,375.4772231853364 805,380 C 854.3836244220578,384.5227768146636 884.0475457705514,392.587594892327 924,404 C 963.9524542294486,415.412405107673 1014.1934413398521,430.1723972453557 1053,427 C 1091.8065586601479,423.8276027546443 1119.1786888700399,402.72281612625034 1165,403 C 1210.8213111299601,403.27718387374966 1275.0918031799886,424.9363382496428 1324,428 C 1372.9081968200114,431.0636617503572 1406.4540984100058,415.53183087517857 1440,400 C 1440,400 1440,500 1440,500 Z" stroke="none" strokeWidth="0" fill="#f4f8f8ff" className="transition-all duration-300 ease-in-out delay-150 path-3"></path></svg>
                        </div>
                        <div className='cardC'>
                            <div className='left'>
                                <span className='title'>Login This Month</span>
                                <span className='count'>30</span>
                                <span className='badge'>{GetFormattedDate()}</span>
                            </div>
                            <div className='right'>
                                <span className='svg'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" className="bi bi-graph-up-arrow" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M0 0h1v15h15v1H0V0Zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5Z" />
                                    </svg>
                                </span>
                            </div>
                        </div>
                        
                    </div>
                    <div className="dashBottom">
                        <LiveClassesMini />
                        <InstallmentsMini />
                    </div>
                    <div className="dashBottom2">
                        <ScoresMini />
                       {(isSkl || isSuperAdmin) && <EnquiryMini />}
                    </div>

                    <Footer />
                </div>
            </>
        );
    }
}

export default Dashboard;